import api from './api';

// Commandes VN : couverture par version (ventes nettes + stock lus dans
// A97 Data), dossiers de commande → lots (ETA, paiement prévu, statuts).
const p = (concessionId, marque) => ({ concession_id: concessionId, marque });

const commandesVn = {
  perimetres: () => api.get('/commandes-vn/perimetres'),
  couverture: (c, m) => api.get('/commandes-vn/couverture', { params: p(c, m) }),
  calendrier: (c, m) => api.get('/commandes-vn/calendrier', { params: p(c, m) }),
  enregistrerParametres: (c, m, data) => api.put('/commandes-vn/parametres', { ...p(c, m), ...data }),
  ajouterVersion: (c, m, data) => api.post('/commandes-vn/versions', { ...p(c, m), ...data }),
  modifierVersion: (id, data) => api.put(`/commandes-vn/versions/${id}`, data),
  correspondances: (c, m) => api.get('/commandes-vn/correspondances', { params: p(c, m) }),
  classer: (id, data) => api.put(`/commandes-vn/correspondances/${id}`, data),
  confirmerPropositions: (c, m) => api.post('/commandes-vn/correspondances/confirmer', p(c, m)),
  ajusterPrevision: (versionId, ym, quantite) => api.put('/commandes-vn/previsions', { version_id: versionId, ym, quantite }),
  commandes: (c, m) => api.get('/commandes-vn/commandes', { params: p(c, m) }),
  commande: (id) => api.get(`/commandes-vn/commandes/${id}`),
  creerCommande: (c, m, data) => api.post('/commandes-vn/commandes', { ...p(c, m), ...data }),
  modifierCommande: (id, data) => api.put(`/commandes-vn/commandes/${id}`, data),
  supprimerCommande: (id) => api.delete(`/commandes-vn/commandes/${id}`),
  ajouterLot: (commandeId, data) => api.post(`/commandes-vn/commandes/${commandeId}/lots`, data),
  modifierLot: (id, data) => api.put(`/commandes-vn/lots/${id}`, data),
  fractionnerLot: (id, quantite, eta) => api.post(`/commandes-vn/lots/${id}/fractionner`, { quantite, eta }),
  supprimerLot: (id) => api.delete(`/commandes-vn/lots/${id}`),
};

export default commandesVn;
